import SectionHeading from '../../components/SectionHeading';
import RichText from '../../components/RichText';
import Loader from '../../components/Loader';
import CategoryIcon from '../../components/CategoryIcon';
import useFetch from '../../hooks/useFetch';
import { getFeatures } from '../../services/api';

const FALLBACK_FEATURES = [
  {
    id: '1',
    icon: '🛡️',
    title: 'Authorized & Verified Supply Chain',
    description:
      'Every product comes with proper brand authorization, giving you legitimate invoices Amazon requires for ungating and approvals.',
  },
  {
    id: '2',
    icon: '⚡',
    title: 'Fast, Reliable Fulfillment',
    description:
      'Orders ship from our U.S. warehouses promptly, keeping your FBA inventory stocked and your sales momentum going.',
  },
  {
    id: '3',
    icon: '📈',
    title: 'High ROI, Low BSR Products',
    description:
      'We curate products with strong profit margins and proven sales velocity so you can scale with confidence.',
  },
  {
    id: '4',
    icon: '🤝',
    title: 'Dedicated Expert Support',
    description:
      'Your account manager is always a message away — familiar with your business and ready to solve problems quickly.',
  },
];

const FALLBACK_STATS = [
  { label: 'Active Wholesale Accounts', value: '500+' },
  { label: 'Years in Business', value: '7+ Yrs' },
  { label: 'Products in Catalog', value: '10K+' },
  { label: 'Free Shipping Threshold', value: '$500' },
  { label: 'Client Satisfaction Rate', value: '100%' },
];

function WhyUsSection({ settings }) {
  const { data, loading } = useFetch(() => getFeatures(), []);

  const features =
    Array.isArray(data) && data.length > 0
      ? data
      : loading
      ? []
      : FALLBACK_FEATURES;

  const whyStats =
    Array.isArray(settings?.why_us_stats) && settings.why_us_stats.length > 0
      ? settings.why_us_stats
      : FALLBACK_STATS;

  return (
    <section style={{ background: 'var(--light-bg)' }}>
      <div className="section-inner">
        <div className="why-grid">
          <div>
            <SectionHeading
              label="Why Nation Wholesale"
              title="Built for Amazon Sellers. Trusted by Businesses."
              sub="We don't just ship products — we build long-term partnerships that help you grow."
            />
            {loading ? (
              <Loader />
            ) : (
              <div className="why-list">
                {features.map((feature) => (
                  <div className="why-item" key={feature.id}>
                    <div className="why-icon-wrap">
                      <CategoryIcon
                        icon={feature.icon}
                        fallback="✓"
                        alt={feature.title}
                      />
                    </div>
                    <div>
                      <h4>{feature.title}</h4>
                      <RichText html={feature.description} tag="p" />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="why-visual">
            {whyStats.map((stat, i) => (
              <div className="stat-row" key={i}>
                <div className="stat-row-label">{stat.label}</div>
                <div className="stat-row-val">{stat.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUsSection;
